import { MedicalExamCertificateRestriction } from './medical-exam-certificate-restriction.model';

export class MedicalExamCertificate {
    public id: number;
    public customerNumberId: number;
    public documentId: number;
    public medicalExamCertificateDecisionTypeId: number;
    public decisionDisplayValue: string;
    public medicalExaminerFirstName: string;
    public medicalExaminerMiddleName: string;
    public medicalExaminerLastName: string;
    public medicalExaminerSuffixTypeId: number;
    public medicalExaminerLicenseNumber: string;
    public medicalExaminerSpecialtyCodeId: number;
    public medicalExaminerPhoneNumber: string;
    public medicalExaminerRegistryCode: string;
    public medicalExamCertificateIssuingJurisdictionId: number;
    public jurisdictionDisplayValue: string;
    public medicalExamCertificateSignatureDate: Date;
    public speCertificateEffectiveDate: Date;
    public speCertificateEndDate: Date;
    public isLongMedicalExamForm: boolean;
    public isGrandfatherEligible: boolean;
    public restrictions: MedicalExamCertificateRestriction[];
    public restrictionDisplayValues: string;
    public restrictionCodesDisplayValues: string;
    public conditionIds: number[];
    public confirmAdminAction: boolean;
    public customerIndividualMedicalReportId: number;
    public effectiveDate: Date;
    public expirationDate: Date;
    public eligibleExpirationDate: Date;
    public meetsMedicalStandards: boolean;
    public medicalExamCertificateStatus: string;
    public businessTransactionNumberId: number;
    public driverMedicalCertificateStatusTypeId: number;
    public driverMedicalCertificateStatusTypeDisplayValue: string;
    public qualificationStatusDate: Date;
    public updatedDate: Date;
}
